import * as ReactDOMClient from 'react-dom/client';
import { IReactDOMAdapter } from '../type';

export const reactDomAdapter18: IReactDOMAdapter = {
    render: (element, container) => {
        const root = ReactDOMClient.createRoot(container);
        root.render(element);
        return root;
    },
    unmount: (container, root) => {
        root?.unmount?.();
    }
};
